module.exports = __webpack_public_path__ + "static/media/illust_cat_at_window.17ea01c1.png";